module.exports = __webpack_public_path__ + "static/media/OutcomeOption.74a86bb0.svg";